import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Spin,
  Form,
  Card,
  Select,
  DatePicker,
  InputNumber,
  Dropdown,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";

import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import Settings01 from "@untitled-ui/icons-react/build/esm/Settings01";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "../treasuryContractBooking.config";
import { BOM } from "../../../services/definedMethod";

const ViewAuction = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const currencyOptions = [
    { label: "NGN – Nigerian Naira", value: "NGN" },
    { label: "USD – US Dollar", value: "USD" },
    { label: "EUR – Euro", value: "EUR" },
    { label: "GBP – British Pound", value: "GBP" },
  ];

  useEffect(() => {
    if (id) {
      fetchAuctionDetail(id);
    }
  }, [id]);

  const fetchAuctionDetail = async (auctionId) => {
    try {
      setIsLoading(true);

      // const res = await BOM.SendReq(apiConfig.getAuctionById, { id: auctionId });
      // const data = res.data;

      const data = {
        productId: 1,
        productLabel: "Product A",
        securityMasterId: 1,
        securityMasterLabel: "Security Master A",
        auctionDate: "2026-02-22",
        settlementDate: "2026-02-24",
        maturityDate: "2026-05-25",
        totalOffered: 1000000000.0,
        currencyCode: "NGN",
      };

      form.setFieldsValue({
        productId: data.productId,
        securityMasterId: data.securityMasterId,
        auctionDate: dayjs(data.auctionDate),
        settlementDate: dayjs(data.settlementDate),
        maturityDate: dayjs(data.maturityDate),
        totalOffered: data.totalOffered,
        currencyCode: data.currencyCode,
      });
    } catch (error) {
      BOM.AlertMsg(cnt.DANGER, error?.message || "Failed to load auction details.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAction = ({ key }) => {
    switch (key) {
      case "open_auction":
        // BOM.SendReq(apiConfig.openAuction, { id });
        break;
      case "close_auction":
        // BOM.SendReq(apiConfig.closeAuction, { id });
        break;
      case "publish_auction":
        // BOM.SendReq(apiConfig.publishAuction, { id });
        break;
      case "auction_results":
        // navigate(`/auction/${id}/results`);
        break;
      case "cancel_auction":
        // BOM.SendReq(apiConfig.cancelAuction, { id });
        break;
      case "add_auction_line":
        navigate(`/add-auction-line`);
        break;
      case "create_auction_bid":
        navigate(`/create-aution-bid`);
        break;
      case "submit_bid":
        // BOM.SendReq(apiConfig.submitBid, { id });
        break;
      case "record_auction_results":
        navigate(`/record-auction-result`);
        break;
      case "create_auction_allotment":
        navigate(`/create-auction-allotment`);
        break;
      default:
        break;
    }
  };

  const actionMenuItems = [
    {
      key: "open_auction",
      label: "Open Auction",
    },
    {
      key: "close_auction",
      label: "Close Auction",
    },
    {
      key: "publish_auction",
      label: "Publish Auction",
    },
    {
      key: "auction_results",
      label: "Auction Results",
    },
    {
      type: "divider",
    },
    {
      key: "cancel_auction",
      label: (
        <span style={{ color: "#B42318" }}>Cancel Auction</span>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "add_auction_line",
      label: "Add Auction Line",
    },
    {
      key: "create_auction_bid",
      label: "Create Auction Bid",
    },
    {
      key: "submit_bid",
      label: "Submit Bid",
    },
    {
      key: "record_auction_results",
      label: "Record Auction Results",
    },
    {
      key: "create_auction_allotment",
      label: "Create Auction Allotment",
    },
  ];

  const disabledStyle = {
    height: 44,
    background: "#F9FAFB",
    cursor: "not-allowed",
  };

  return (
    <MainLayout pageItems={staticConfig.newAuction}>
      <TopContent
        pageTitle={labelConfig.securityProduct}
        // createPageTitle={labelConfig.auctionDetail}
      />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            {/* Header row: title left, actions right */}
            <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
              <Col>
                <h3 style={{ margin: 0, fontWeight: 600 }}>Auction Details</h3>
              </Col>
              <Col>
                <Dropdown
                  menu={{ items: actionMenuItems, onClick: handleAction }}
                  trigger={["click"]}
                  placement="bottomRight"
                >
                  <button
                    type="button"
                    style={{
                      height: 44,
                      padding: "0 20px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <Settings01 width={16} height={16} color="#344054" />
                    Actions
                    <ChevronDown width={16} height={16} color="#667085" />
                  </button>
                </Dropdown>
              </Col>
            </Row>

            <Form layout="vertical" form={form}>

              {/* Product & Security Master */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Product
                        <Tooltip title="The product this auction is linked to.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="productId"
                  >
                    <Select
                      style={disabledStyle}
                      suffixIcon={<ChevronDown color="#667085" />}
                      placeholder="—"
                      disabled
                    />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Security Master
                        <Tooltip title="The underlying security instrument tied to this auction.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="securityMasterId"
                  >
                    <Select
                      style={disabledStyle}
                      suffixIcon={<ChevronDown color="#667085" />}
                      placeholder="—"
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Auction Date & Settlement Date */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Auction Date
                        <Tooltip title="The date on which the auction was conducted.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="auctionDate"
                  >
                    <DatePicker
                      style={{ width: "100%", height: 44, background: "#F9FAFB", cursor: "not-allowed" }}
                      format="YYYY-MM-DD"
                      disabled
                    />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Settlement Date
                        <Tooltip title="The date by which funds and securities are exchanged.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="settlementDate"
                  >
                    <DatePicker
                      style={{ width: "100%", height: 44, background: "#F9FAFB", cursor: "not-allowed" }}
                      format="YYYY-MM-DD"
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Maturity Date & Currency */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Maturity Date
                        <Tooltip title="The date on which the auctioned instrument reaches maturity.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="maturityDate"
                  >
                    <DatePicker
                      style={{ width: "100%", height: 44, background: "#F9FAFB", cursor: "not-allowed" }}
                      format="YYYY-MM-DD"
                      disabled
                    />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Currency
                        <Tooltip title="The currency in which the auction is denominated.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="currencyCode"
                  >
                    <Select
                      style={disabledStyle}
                      suffixIcon={<ChevronDown color="#667085" />}
                      options={currencyOptions}
                      placeholder="—"
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Total Offered */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Total Offered
                        <Tooltip title="The total face value amount offered at this auction.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="totalOffered"
                  >
                    <InputNumber
                      style={{ width: "100%", height: 44, background: "#F9FAFB", cursor: "not-allowed" }}
                      formatter={(value) =>
                        value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
                      }
                      parser={(value) => value?.replace(/,/g, "")}
                      precision={2}
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Divider */}
              <div style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }} />

              {/* Back button */}
              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate("/auction")}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    Back
                  </button>
                </Col>
              </Row>

            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, { rightAction })(ViewAuction);